import {
  configApiRef,
  createFrontendModule,
  featureFlagsApiRef,
} from '@backstage/frontend-plugin-api';
import type { ApiHolder } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { readInitialKind, readInitialScope } from './upstreamFilterConfig';

export const CATALOG_TOP_FILTERS_FLAG = 'catalog-top-filters';

const topFiltersEnabled = (apis: ApiHolder) =>
  apis.get(featureFlagsApiRef)?.isActive(CATALOG_TOP_FILTERS_FLAG) ?? false;

export const catalogIndexPage = catalogPlugin
  .getExtension('page:catalog')
  .override({
    factory(originalFactory, { apis, config }) {
      if (!topFiltersEnabled(apis)) {
        return originalFactory();
      }

      const { pagination } = config as {
        pagination?: boolean | { mode?: string; limit?: number };
      };
      const initialLimit =
        typeof pagination === 'object' ? pagination.limit : undefined;

      // Both come off upstream's own filter extensions, so the two catalog
      // pages open the same way whichever the flag renders.
      const configApi = apis.get(configApiRef);
      const initialScope = configApi ? readInitialScope(configApi) : undefined;
      const initialKind = configApi ? readInitialKind(configApi) : undefined;

      return originalFactory({
        params: {
          loader: async () => {
            const { CatalogIndexPage } = await import('./CatalogIndexPage');
            return (
              <CatalogIndexPage
                initialLimit={initialLimit}
                initialScope={initialScope}
                initialKind={initialKind}
              />
            );
          },
        },
      });
    },
  });

export const catalogIndexModule = createFrontendModule({
  pluginId: 'catalog',
  featureFlags: [
    {
      name: CATALOG_TOP_FILTERS_FLAG,
      description:
        'Replace the catalog index page with kind tabs and a filter bar above a full-width table, instead of the built-in left filter rail',
    },
  ],
  extensions: [catalogIndexPage],
});
